import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "../css/AppChrome.css";
import logoWeb from "../assets/BootLoop_Web_Logo.png";

const AppHeader: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);
  const loc = useLocation();

  // Close menus on navigation
  React.useEffect(() => {
    setMenuOpen(false);
    setAdminOpen(false);
  }, [loc.pathname]);

  return (
    <header className="lp2__header">
      <div className="lp2__container lp2__headerInner">
        {/* ✅ Customer entry point */}
        <Link to="/find-swap-v2" className="lp2__brand" aria-label="BootLoop">
          <img className="lp2__logo" src={logoWeb} alt="BootLoop" />
        </Link>

        {/* =========================
            Desktop navigation
           ========================= */}
        <nav className="lp2__nav" aria-label="App navigation">
          {/* ✅ Customer journey first */}
          <NavLink className="lp2__navLink" to="/find-swap-v2">
            Find a swap
          </NavLink>

          {/* ✅ NEW: browse all boots */}
          <NavLink className="lp2__navLink" to="/boots">
            Boots available
          </NavLink>

          <NavLink className="lp2__navLink" to="/list-boot">
            List boots
          </NavLink>

          <NavLink className="lp2__navLink" to="/my">
            My stuff
          </NavLink>

          {/* Admin dropdown */}
          <div
            className="lp2__navLink"
            style={{ position: "relative", cursor: "pointer" }}
            onMouseEnter={() => setAdminOpen(true)}
            onMouseLeave={() => setAdminOpen(false)}
          >
            Admin ▾

            {adminOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  right: 0,
                  background: "rgba(20, 24, 40, 0.95)",
                  borderRadius: 10,
                  padding: 8,
                  minWidth: 200,
                  zIndex: 50,
                }}
              >
                <NavLink className="lp2__navLink" to="/admin/interests">
                  Interests
                </NavLink>

                <NavLink className="lp2__navLink" to="/admin/search-audit">
                  Search audit
                </NavLink>

                {/* Optional: keep old/internal pages accessible but out of the main nav */}
                <div
                  style={{
                    height: 1,
                    background: "rgba(255,255,255,0.12)",
                    margin: "8px 0",
                  }}
                />

                <NavLink className="lp2__navLink" to="/dashboard">
                  Dashboard (internal)
                </NavLink>

                <NavLink className="lp2__navLink" to="/list-boots">
                  List boots (legacy)
                </NavLink>

                <NavLink className="lp2__navLink" to="/find-swap-v2-old">
                  Find swap (legacy)
                </NavLink>
              </div>
            )}
          </div>

          {/* ✅ CTA points at new listing wizard */}
          <NavLink className="lp2__navCta" to="/list-boot">
            Add listing
          </NavLink>
        </nav>

        {/* =========================
            Mobile burger
           ========================= */}
        <button
          className="lp2__burger"
          type="button"
          aria-label="Open menu"
          aria-expanded={menuOpen ? "true" : "false"}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* =========================
          Mobile menu
         ========================= */}
      {menuOpen && (
        <div className="lp2__mobileMenu" role="dialog" aria-label="Mobile menu">
          {/* ✅ Customer journey first */}
          <NavLink className="lp2__mobileLink" to="/find-swap-v2">
            Find a swap
          </NavLink>

          {/* ✅ FIX: apply the same mobile link class so it styles correctly */}
          <NavLink className="lp2__mobileLink" to="/boots">
            Boots available
          </NavLink>

          <NavLink className="lp2__mobileLink" to="/list-boot">
            List boots
          </NavLink>

          <NavLink className="lp2__mobileLink" to="/my">
            My stuff
          </NavLink>

          {/* Admin section */}
          <div style={{ marginTop: 10 }}>
            <div className="lp2__mobileLink" style={{ opacity: 0.7 }}>
              Admin
            </div>

            <NavLink className="lp2__mobileLink" to="/admin/interests">
              • Interests
            </NavLink>

            <NavLink className="lp2__mobileLink" to="/admin/search-audit">
              • Search audit
            </NavLink>

            {/* Optional: internal/legacy pages */}
            <NavLink className="lp2__mobileLink" to="/dashboard">
              • Dashboard (internal)
            </NavLink>

            <NavLink className="lp2__mobileLink" to="/list-boots">
              • List boots (legacy)
            </NavLink>

            <NavLink className="lp2__mobileLink" to="/find-swap-v2-old">
              • Find swap (legacy)
            </NavLink>
          </div>

          <NavLink className="lp2__mobileCta" to="/list-boot">
            Add listing
          </NavLink>
        </div>
      )}
    </header>
  );
};

export default AppHeader;